import { useState, useEffect, useCallback } from 'react';

const PHOTOS = [
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/8db1a512-0dd6-4b23-9fda-3dd8a98941a4_compressed_IMG_0131.webp',
    alt: 'Кованая мебель — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Finished%20wrought%20iron%20dining%20table%20with%20wooden%20top%20and%20decorative%20scrollwork%20base%20installed%20in%20a%20private%20home%20Russia%20warm%20interior%20lighting%20dark%20charcoal%20paint%20realistic%20photo&width=800&height=600&seq=furn-work-1&orientation=landscape',
    alt: 'Кованый стол — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Elegant%20set%20of%20wrought%20iron%20chairs%20with%20upholstered%20seats%20around%20a%20table%20in%20a%20bright%20Russian%20home%20interior%20classic%20forged%20elements%20dark%20finish%20warm%20lighting%20realistic%20photo&width=800&height=600&seq=furn-work-2&orientation=landscape',
    alt: 'Кованые стулья — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20garden%20furniture%20set%20table%20and%20chairs%20placed%20on%20a%20patio%20in%20a%20private%20garden%20Russia%20summer%20daylight%20green%20background%20forged%20decorative%20elements%20realistic%20photo&width=800&height=600&seq=furn-work-3&orientation=landscape',
    alt: 'Садовая кованая мебель — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20bench%20with%20soft%20seat%20cushion%20placed%20in%20hallway%20of%20Russian%20private%20house%20dark%20metal%20scrollwork%20frame%20elegant%20classic%20interior%20realistic%20photo%20warm%20light&width=800&height=600&seq=furn-work-4&orientation=landscape',
    alt: 'Кованая банкетка — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Decorative%20wrought%20iron%20console%20table%20with%20wooden%20top%20against%20wall%20in%20elegant%20Russian%20home%20entryway%20dark%20charcoal%20finish%20ornate%20forged%20legs%20realistic%20interior%20photo&width=800&height=600&seq=furn-work-5&orientation=landscape',
    alt: 'Кованая консоль — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20terrace%20furniture%20set%20with%20sofa%20and%20armchairs%20cushions%20installed%20on%20open%20veranda%20Russian%20house%20garden%20background%20warm%20afternoon%20light%20forged%20black%20frame%20realistic%20photo&width=800&height=600&seq=furn-work-6&orientation=landscape',
    alt: 'Мебель для террасы — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Finished%20wrought%20iron%20coffee%20table%20with%20glass%20top%20in%20living%20room%20Russia%20interior%20dark%20elegant%20metalwork%20base%20decorative%20elements%20warm%20lighting%20realistic%20photo%20close%20up&width=800&height=600&seq=furn-work-7&orientation=landscape',
    alt: 'Кованый журнальный столик — готовый объект',
  },
];

export default function VariantsSection() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const open = (idx: number) => setLightboxIndex(idx);
  const close = () => setLightboxIndex(null);

  const goPrev = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? (prev - 1 + PHOTOS.length) % PHOTOS.length : null));
  }, []);

  const goNext = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? (prev + 1) % PHOTOS.length : null));
  }, []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [lightboxIndex, goPrev, goNext]);

  const currentPhoto = lightboxIndex !== null ? PHOTOS[lightboxIndex] : null;

  return (
    <>
      <section className="py-16 md:py-20 bg-background-100">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Примеры наших работ
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Реальная кованая мебель, которую мы уже изготовили для наших клиентов
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3">
            {PHOTOS.map((photo, idx) => (
              <div
                key={idx}
                role="button"
                tabIndex={0}
                onClick={() => open(idx)}
                onKeyDown={(e) => { if (e.key === 'Enter') open(idx); }}
                className="relative group rounded-md overflow-hidden bg-background-200 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
              >
                <div className="w-full h-44 md:h-52">
                  <img
                    src={photo.src}
                    alt={photo.alt}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50">
                    <i className="ri-zoom-in-line text-xl"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {currentPhoto && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm animate-fade-in"
          onClick={close}
        >
          <button
            onClick={close}
            className="whitespace-nowrap absolute top-5 right-5 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Закрыть"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
            className="whitespace-nowrap absolute left-3 md:left-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Предыдущее"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); goNext(); }}
            className="whitespace-nowrap absolute right-3 md:right-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Следующее"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div
            className="max-w-[90vw] max-h-[85vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={currentPhoto.src}
              alt={currentPhoto.alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-background-50/80 text-sm text-center mt-4 max-w-lg">
              {currentPhoto.alt}
            </p>
            <p className="text-background-50/40 text-xs mt-1">
              {lightboxIndex! + 1} / {PHOTOS.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
}